<template>
  <section id="seen-on" class="seen-on">
    <div class="grid grid--container">
      <slot />
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss">
.seen-on {
  background: #f8f8f8;
  padding: 1.875rem 0 2.5rem;
  text-align: center;

  > .grid {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1.5rem;
  }

  h2 {
    margin-bottom: 1.875rem;
    margin-top: -0.625rem;
    text-align: center;
    width: 100%;
  }

  p {
    color: #919191;
    font-size: 1.375rem;
    width: 100%;
    margin-bottom: 0;
  }

  img {
    flex-shrink: 0;
    filter: grayscale(100%);
    max-height: 5rem;
    max-width: 11rem;
  }

  .participant {
    max-height: 4.375rem;
  }
}

@media (min-width: 992px) {
  .seen-on {
    padding: 3.125rem 0;
    text-align: left;

    > .grid {
      gap: 2.5rem;
    }

    p {
      font-size: 1.25rem;
      width: auto;
    }
  }
}
</style>
